import {TtProductEntry} from '../../interfaces/time-tracking/tt-product-entry';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightProduct} from '../../interfaces/product-management/light-product';
import {LightProductFactory} from '../product-management/light-product-factory';


export class TtProductEntryFactory {

  /**
   *
   * @param ttProductEntry
   */
  public static fromObject(ttProductEntry: any): TtProductEntry {
    return new class implements TtProductEntry {
      amount: number = ttProductEntry.amount;
      customer: LightCustomer =
        ttProductEntry.customer ? LightCustomerFactory.fromObject(ttProductEntry.customer) : null;
      customerId: number = ttProductEntry.customer_id;
      customerServiceFacilityId: number = ttProductEntry.customer_service_facility_id;
      date: string = ttProductEntry.date;
      employee: LightEmployee = LightEmployeeFactory.fromObject(ttProductEntry.employee);
      employeeId: number = ttProductEntry.employee_id;
      employeeServiceFacilityId: number = ttProductEntry.employee_service_facility_id;
      ttActivityEntryUuid: string = ttProductEntry.tt_activity_entry_uuid;
      invMobileInvoiceId: number = ttProductEntry.inv_mobile_invoice_id;
      product: LightProduct = LightProductFactory.fromObject(ttProductEntry.product);
      productId: number = ttProductEntry.product_id;
      user: LightUser = LightUserFactory.fromObject(ttProductEntry.user);
      userId: number = ttProductEntry.user_id;

      // ------------------------------------------------------------------------------------------------
      id: number = ttProductEntry.id;
      uuid: string = ttProductEntry.uuid;
      modified: string = ttProductEntry.modified;
      created: string = ttProductEntry.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param ttProductEntries
   */
  public static fromArray(ttProductEntries: any[]): TtProductEntry[] {
    return ttProductEntries.map((_ttProductEntry) => TtProductEntryFactory.fromObject(_ttProductEntry));
  }

  /**
   *
   * @param ttProductEntry
   */
  public static toRemote(ttProductEntry: TtProductEntry): any {
    return {
      amount: ttProductEntry.amount,
      customer_id: ttProductEntry.customerId,
      date: ttProductEntry.date,
      employee_id: ttProductEntry.employeeId,
      id: ttProductEntry.id,
      uuid: ttProductEntry.uuid,
      tt_activity_entry_uuid: ttProductEntry.ttActivityEntryUuid,
      product_id: ttProductEntry.productId
    };
  }

  /**
   *
   * @param ttProductEntries
   */
  public static toArray(ttProductEntries: TtProductEntry[]): any[] {
    return ttProductEntries.map((_ttProductEntry) => TtProductEntryFactory.toRemote(_ttProductEntry));
  }


  /**
   *
   */
  public static new(ttProductEntry: Partial<TtProductEntry> = null): TtProductEntry {
    const newTtProductEntry = new class implements TtProductEntry {
      amount: number = 1;
      customer: LightCustomer = null;
      customerId: number = null;
      customerServiceFacilityId: number = null;
      date: string = null;
      employee: LightEmployee = null;
      employeeId: number = null;
      employeeServiceFacilityId: number = null;
      ttActivityEntryUuid: string = null;
      invMobileInvoiceId: number = null;
      product: LightProduct = null;
      productId: number = null;
      user: LightUser = null;
      userId: number = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
    };

    if(ttProductEntry) {
      return {...newTtProductEntry, ...ttProductEntry};
    }

    return newTtProductEntry;
  }

}
